import { Union, Record } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { CustomerGroup_$reflection, Dashboard_ActivityCompanyEntry_$reflection, Dashboard_TypeSummaryEntry_$reflection, Dashboard_ActivitiesSummary_$reflection } from "../Shared/ApiDataTypes.js";
import { obj_type, union_type, record_type, string_type, int32_type, class_type, array_type, option_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { FetchError, FetchError_$reflection } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Result_MapError, FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { addMonths, now as now_1 } from "../fable_modules/fable-library-js.4.24.0/Date.js";
import { some, unwrap, map, bind, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { ServiceType__ToString_12C6553D, ServiceType_FromId_88FA7A4, DateOnly_iso, DateOnly_tryParse } from "../Shared/Shared.js";
import { removeQuery, setQuery, tryInt, getQuery } from "../Utils.js";
import { parse, fromDateTime } from "../fable_modules/fable-library-js.4.24.0/DateOnly.js";
import { sortByDescending, map as map_1, tryFind } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { generateQueryString } from "../Shared/Urls.js";
import { toList, empty, singleton, append, delay, toArray } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { equals, comparePrimitives, createObj, uncurry2, int32ToString } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { testRedirect, extraCoders } from "../Promises.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { singleton as singleton_1, cons, ofArray, empty as empty_1 } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { toString } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6 } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { fromString } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { join } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { TextField, Table, TableBody, TableRow, TableCell, Skeleton, Typography } from "@mui/material";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { reactApi as reactApi_1 } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ResponsiveContainer, PieChart, Pie, Cell } from "recharts";
import Circle from "@mui/icons-material/Circle";
import { ctx as ctx_1 } from "../Context.js";
import { CustomerGroup_fetchGroups } from "../Promises.js";
import { SnackError } from "../ViewHelpers.js";
import { Components_CustomerGroupSelect_Z3E74A903 } from "../Components/CustomerGroupSelect.js";

class Model extends Record {
    constructor(Summary, TypeSummary, CompanySpread, PeriodStart, PeriodEnd, CustomerGroups, SelectedGroup, SelectedGroupId, ErrorMsg) {
        super();
        this.Summary = Summary;
        this.TypeSummary = TypeSummary;
        this.CompanySpread = CompanySpread;
        this.PeriodStart = PeriodStart;
        this.PeriodEnd = PeriodEnd;
        this.CustomerGroups = CustomerGroups;
        this.SelectedGroup = SelectedGroup;
        this.SelectedGroupId = SelectedGroupId;
        this.ErrorMsg = ErrorMsg;
    }
}

function Model_$reflection() {
    return record_type("Dashboards.Activities.Model", [], Model, () => [["Summary", option_type(Dashboard_ActivitiesSummary_$reflection())], ["TypeSummary", option_type(array_type(Dashboard_TypeSummaryEntry_$reflection()))], ["CompanySpread", option_type(array_type(Dashboard_ActivityCompanyEntry_$reflection()))], ["PeriodStart", class_type("System.DateOnly")], ["PeriodEnd", class_type("System.DateOnly")], ["CustomerGroups", array_type(CustomerGroup_$reflection())], ["SelectedGroup", option_type(CustomerGroup_$reflection())], ["SelectedGroupId", option_type(int32_type)], ["ErrorMsg", option_type(string_type)]]);
}

class Message extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SummaryResponse", "TypeSummaryResponse", "CompanySpreadResponse", "GroupsResponse", "UpdatePeriodStart", "UpdatePeriodEnd", "SelectGroup", "DismissError"];
    }
}

function Message_$reflection() {
    return union_type("Dashboards.Activities.Message", [], Message, () => [[["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [Dashboard_ActivitiesSummary_$reflection(), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", Dashboard_ActivitiesSummary_$reflection()]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Dashboard_TypeSummaryEntry_$reflection()), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(Dashboard_TypeSummaryEntry_$reflection())]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Dashboard_ActivityCompanyEntry_$reflection()), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(Dashboard_ActivityCompanyEntry_$reflection())]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(CustomerGroup_$reflection()), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(CustomerGroup_$reflection())]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item", class_type("System.DateOnly")]], [["Item", class_type("System.DateOnly")]], [["Item", option_type(CustomerGroup_$reflection())]], []]);
}

function init() {
    const now = now_1();
    return new Model(undefined, undefined, undefined, defaultArg(bind(DateOnly_tryParse, getQuery("start")), fromDateTime(now)), defaultArg(bind(DateOnly_tryParse, getQuery("end")), fromDateTime(addMonths(now, 1))), [], undefined, bind(tryInt, getQuery("group")), undefined);
}

function update(model, msg) {
    switch (msg.tag) {
        case 1: {
            const res_1 = msg.fields[0];
            if (res_1.tag === 1) {
                return model;
            }
            else {
                return new Model(model.Summary, res_1.fields[0], model.CompanySpread, model.PeriodStart, model.PeriodEnd, model.CustomerGroups, model.SelectedGroup, model.SelectedGroupId, model.ErrorMsg);
            }
        }
        case 2: {
            const res_2 = msg.fields[0];
            if (res_2.tag === 1) {
                return model;
            }
            else {
                return new Model(model.Summary, model.TypeSummary, res_2.fields[0], model.PeriodStart, model.PeriodEnd, model.CustomerGroups, model.SelectedGroup, model.SelectedGroupId, model.ErrorMsg);
            }
        }
        case 3: {
            const res_3 = msg.fields[0];
            if (res_3.tag === 0) {
                const groups = res_3.fields[0];
                return new Model(model.Summary, model.TypeSummary, model.CompanySpread, model.PeriodStart, model.PeriodEnd, groups, bind((id) => tryFind((group) => (group.Id === id), groups), model.SelectedGroupId), model.SelectedGroupId, model.ErrorMsg);
            }
            else {
                return model;
            }
        }
        case 4:
            return new Model(model.Summary, model.TypeSummary, model.CompanySpread, msg.fields[0], model.PeriodEnd, model.CustomerGroups, model.SelectedGroup, model.SelectedGroupId, model.ErrorMsg);
        case 5:
            return new Model(model.Summary, model.TypeSummary, model.CompanySpread, model.PeriodStart, msg.fields[0], model.CustomerGroups, model.SelectedGroup, model.SelectedGroupId, model.ErrorMsg);
        case 6:
            return new Model(model.Summary, model.TypeSummary, model.CompanySpread, model.PeriodStart, model.PeriodEnd, model.CustomerGroups, msg.fields[0], model.SelectedGroupId, model.ErrorMsg);
        case 7:
            return new Model(model.Summary, model.TypeSummary, model.CompanySpread, model.PeriodStart, model.PeriodEnd, model.CustomerGroups, model.SelectedGroup, model.SelectedGroupId, undefined);
        default: {
            const res = msg.fields[0];
            if (res.tag === 1) {
                return model;
            }
            else {
                return new Model(res.fields[0], model.TypeSummary, model.CompanySpread, model.PeriodStart, model.PeriodEnd, model.CustomerGroups, model.SelectedGroup, model.SelectedGroupId, model.ErrorMsg);
            }
        }
    }
}

function toUrl(basePath, periodStart, periodEnd, group) {
    return basePath + generateQueryString(toArray(delay(() => append(singleton(["from", DateOnly_iso(periodStart)]), delay(() => append(singleton(["until", DateOnly_iso(periodEnd)]), delay(() => {
        const matchValue = group;
        if (matchValue != null) {
            return singleton(["group", `${matchValue.Id}`]);
        }
        else {
            return empty();
        }
    })))))));
}

function fetchSummary(groupId) {
    let properties_2;
    const url = "/api/dashboard/activities/summary" + generateQueryString(toArray(delay(() => {
        if (groupId != null) {
            return singleton(["group", int32ToString(groupId)]);
        }
        else {
            return empty();
        }
    })));
    let pr_1;
    const decoder = Auto_generateBoxedDecoder_Z6670B51(Dashboard_ActivitiesSummary_$reflection(), undefined, undefined);
    const data_1 = undefined;
    const caseStrategy_2 = undefined;
    const extra_2 = extraCoders;
    try {
        const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty_1()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg) => {
            let response_1, decoder_1_1;
            return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(Dashboard_ActivitiesSummary_$reflection(), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                let matchValue;
                return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
            })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
        }))));
        pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
    }
    catch (exn) {
        pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
    }
    return pr_1.then((result_1) => Result_MapError(testRedirect, result_1));
}

function fetchTypeSummary(periodStart, periodEnd, group) {
    let properties_2;
    const url = toUrl("/api/dashboard/activities/type-spread", periodStart, periodEnd, group);
    let pr_1;
    const decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(Dashboard_TypeSummaryEntry_$reflection()), undefined, undefined);
    const data_1 = undefined;
    const caseStrategy_2 = undefined;
    const extra_2 = extraCoders;
    try {
        const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty_1()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg) => {
            let response_1, decoder_1_1;
            return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(Dashboard_TypeSummaryEntry_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                let matchValue;
                return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
            })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
        }))));
        pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
    }
    catch (exn) {
        pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
    }
    return pr_1.then((result_1) => Result_MapError(testRedirect, result_1));
}

function fetchCompanySpread(periodStart, periodEnd, group) {
    let properties_2;
    const url = toUrl("/api/dashboard/activities/company-spread", periodStart, periodEnd, group);
    let pr_1;
    const decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(Dashboard_ActivityCompanyEntry_$reflection()), undefined, undefined);
    const data_1 = undefined;
    const caseStrategy_2 = undefined;
    const extra_2 = extraCoders;
    try {
        const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty_1()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg) => {
            let response_1, decoder_1_1;
            return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(Dashboard_ActivityCompanyEntry_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                let matchValue;
                return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
            })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
        }))));
        pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
    }
    catch (exn) {
        pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
    }
    return pr_1.then((result_1) => Result_MapError(testRedirect, result_1));
}

function drawSummary(locale, model) {
    let elems_1;
    const infoBox = (title, v) => {
        let elems;
        return createElement("div", createObj(ofArray([["className", join(" ", ["gray-rounded-container"])], ["style", {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            rowGap: 10 + "px",
            flexBasis: 220 + "px",
        }], (elems = toList(delay(() => append(singleton(MuiHelpers_createElement(Typography, [["variant", "h5"], ["noWrap", true], ["children", title]])), delay(() => {
            const matchValue = model.Summary;
            return (matchValue != null) ? singleton(MuiHelpers_createElement(Typography, [["variant", "h2"], ["children", v(matchValue)]])) : singleton(MuiHelpers_createElement(Skeleton, [["variant", "rectangular"], ["height", 30]]));
        })))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
    };
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexWrap: "wrap",
        gap: 30 + "px",
        width: 100 + "%",
    }], (elems_1 = [infoBox(locale.t("Dashboard.Activities.ActivitiesToday"), (a) => a.Today), infoBox(locale.t("Dashboard.Activities.ActivitiesTomorrow"), (a_1) => a_1.Tomorrow), infoBox(locale.t("Dashboard.Activities.ActivitiesThisWeek"), (a_2) => a_2.ThisWeek), infoBox(locale.t("Dashboard.Activities.ActivitiesMonth"), (a_3) => a_3.Month), infoBox(locale.t("Dashboard.Activities.ActivitiesLastSeven"), (a_4) => a_4.LastSeven)], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function drawTypeSummary(locale, language, x) {
    let elems_4;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
    }], (elems_4 = toList(delay(() => {
        let properties_6, value_21, properties_5, elements_1, properties_4, elements;
        if (x != null) {
            const y = x;
            const toPieColorCode = (serviceTypeId) => {
                const _arg = ServiceType_FromId_88FA7A4(serviceTypeId);
                switch (_arg.tag) {
                    case 0:
                        return "#59227a";
                    case 1:
                        return "#ffa500";
                    case 2:
                        return "#962318";
                    case 3:
                        return "#1a8a38";
                    case 4:
                        return "#75abe0";
                    case 5:
                        return "#b664e8";
                    case 6:
                        return "#ffc761";
                    case 7:
                        return "#de584b";
                    case 8:
                        return "#c94966";
                    case 9:
                        return "#e35db4";
                    case 10:
                        return "#a43da6";
                    case 11:
                        return "#8060e0";
                    case 12:
                        return "#0c04b3";
                    case 14:
                        return "#2181db";
                    case 15:
                        return "#3ba2ad";
                    case 16:
                        return "#2ac98f";
                    case 17:
                        return "#5dad3b";
                    default:
                        return "#2c6094";
                }
            };
            const pieData = map_1((z_1) => ({
                Name: ServiceType__ToString_12C6553D(ServiceType_FromId_88FA7A4(z_1.TypeId), language),
                Num: z_1.Num,
                TypeId: z_1.TypeId,
            }), sortByDescending((z) => z.Num, y, {
                Compare: comparePrimitives,
            }));
            return (y.length === 0) ? singleton(createElement("span", {
                children: [locale.t("Services.NoPlanned")],
            })) : append(singleton(createElement("div", {
                style: {
                    width: 400 + "px",
                    height: 300 + "px",
                },
                children: (properties_6 = ofArray([["height", 100 + "%"], (value_21 = (100 + "%"), (equals(value_21, 100 + "%") ? true : equals(value_21, 100 + "%")) ? ["width", 99 + "%"] : ["width", value_21]), ["children", (properties_5 = singleton_1((elements_1 = singleton_1((properties_4 = ofArray([["data", pieData], ["dataKey", "Num"], ["label", true], ["fill", "#59227a"], ["nameKey", "Name"], ["innerRadius", 50], (elements = map_1((z_3) => {
                    const properties_3 = ofArray([["key", ServiceType__ToString_12C6553D(ServiceType_FromId_88FA7A4(z_3.TypeId), language)], ["fill", toPieColorCode(z_3.TypeId)]]);
                    return reactApi_1.createElement(Cell, createObj(properties_3));
                }, sortByDescending((z_2) => z_2.Num, pieData, {
                    Compare: comparePrimitives,
                })), ["children", ["children", reactApi.Children.toArray(Array.from(elements))]])]), reactApi_1.createElement(Pie, createObj(properties_4)))), ["children", reactApi.Children.toArray(Array.from(elements_1))])), reactApi_1.createElement(PieChart, createObj(properties_5)))]]), reactApi_1.createElement(ResponsiveContainer, createObj(properties_6))),
            })), delay(() => {
                let elems_3;
                return singleton(createElement("div", createObj(ofArray([["style", {
                    flexGrow: 1,
                    minWidth: 20 + "ch",
                }], (elems_3 = map_1((t_1) => {
                    let elems_2, props_4;
                    const text = ServiceType__ToString_12C6553D(ServiceType_FromId_88FA7A4(t_1.TypeId), language);
                    return createElement("div", createObj(ofArray([["title", `${text}: ${t_1.Num}`], ["style", {
                        display: "flex",
                        gap: 10 + "px",
                    }], (elems_2 = [createElement("div", {
                        style: {
                            color: toPieColorCode(t_1.TypeId),
                        },
                        children: (props_4 = {}, react.createElement(Circle, props_4)),
                    }), MuiHelpers_createElement(Typography, [["noWrap", true], ["children", text]])], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
                }, sortByDescending((t) => t.Num, y, {
                    Compare: comparePrimitives,
                })), ["children", reactApi.Children.toArray(Array.from(elems_3))])]))));
            }));
        }
        else {
            return singleton(MuiHelpers_createElement(Skeleton, [["variant", "rectangular"], ["style", {
                minWidth: 200,
                minHeight: 200,
            }]]));
        }
    })), ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
}

function drawCompanySpread(locale, x) {
    let elems_3;
    return createElement("div", createObj(ofArray([["className", join(" ", ["bordered-container"])], ["style", {
        display: "flex",
        flexDirection: "column",
        gap: 20 + "px ",
    }], (elems_3 = toList(delay(() => append(singleton(MuiHelpers_createElement(Typography, [["variant", "h5"], ["children", locale.t("Dashboard.Activities.CountByCompany")]])), delay(() => {
        let children_2, children_1;
        const matchValue = x;
        return (matchValue != null) ? singleton((children_2 = singleton_1((children_1 = map_1((z_1) => {
            const children = ofArray([MuiHelpers_createElement(TableCell, [["children", MuiHelpers_createElement(Typography, [["variant", "body3"], ["children", z_1.Company]])]]), MuiHelpers_createElement(TableCell, [["variant", "head"], ["children", MuiHelpers_createElement(Typography, [["variant", "body3-bold"], ["children", z_1.Num]])]])]);
            return MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children))]]);
        }, sortByDescending((z) => z.Num, matchValue, {
            Compare: comparePrimitives,
        })), MuiHelpers_createElement(TableBody, [["children", reactApi.Children.toArray(Array.from(children_1))]]))), MuiHelpers_createElement(Table, [["children", reactApi.Children.toArray(Array.from(children_2))]]))) : singleton(MuiHelpers_createElement(Skeleton, [["variant", "rectangular"], ["style", {
            minWidth: 200,
            minHeight: 200,
        }]]));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

export function View() {
    let elems_3, elems, elems_2, elems_1;
    const ctx = reactApi.useContext(ctx_1);
    let patternInput;
    const arg_1 = init();
    patternInput = reactApi.useReducer(update, arg_1);
    const model_1 = patternInput[0];
    const dispatch = patternInput[1];
    console.debug("Period start ", model_1.PeriodStart);
    reactApi.useEffect(() => {
        const pr = CustomerGroup_fetchGroups(false);
        pr.then((res) => dispatch(new Message(3, [res])));
    }, []);
    reactApi.useEffect(() => {
        const pr_1 = fetchSummary(map((_arg_2) => _arg_2.Id, model_1.SelectedGroup));
        pr_1.then((res_1) => {
            dispatch(new Message(0, [res_1]));
        });
    }, []);
    const dependencies_4 = [model_1.PeriodStart, model_1.PeriodEnd, model_1.SelectedGroup];
    reactApi.useEffect(() => {
        console.debug("[AdminDashboardActivities] Fetching type summaries");
        const pr_2 = fetchTypeSummary(model_1.PeriodStart, model_1.PeriodEnd, model_1.SelectedGroup);
        pr_2.then((res_2) => {
            dispatch(new Message(1, [res_2]));
        });
    }, dependencies_4);
    const dependencies_6 = [model_1.PeriodStart, model_1.PeriodEnd, model_1.SelectedGroup];
    reactApi.useEffect(() => {
        console.debug("[AdminDashboardActivities] Fetching company spread");
        const pr_3 = fetchCompanySpread(model_1.PeriodStart, model_1.PeriodEnd, model_1.SelectedGroup);
        pr_3.then((res_3) => {
            dispatch(new Message(2, [res_3]));
        });
    }, dependencies_6);
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 30 + "px",
    }], (elems_3 = [createElement(SnackError, {
        errMsg: unwrap(model_1.ErrorMsg),
        dismiss: () => {
            dispatch(new Message(7, []));
        },
    }), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        gap: 15 + "px ",
    }], (elems = [MuiHelpers_createElement(TextField, [["type", "date"], ["size", "small"], ["fullWidth", true], ["sx", {
        flexBasis: 230 + "px",
    }], ["label", ctx.Locale.t("FromDate")], ["value", DateOnly_iso(model_1.PeriodStart)], ["onChange", (e) => {
        const x = e.target.value;
        console.debug("period start change", x);
        try {
            const asDt = parse(x);
            const iso = DateOnly_iso(asDt);
            dispatch(new Message(4, [asDt]));
            setQuery("start", iso);
        }
        catch (ex) {
            console.error(some("Error parsing start date"), ex.message);
        }
    }]]), MuiHelpers_createElement(TextField, [["type", "date"], ["size", "small"], ["fullWidth", true], ["sx", {
        flexBasis: 230 + "px",
    }], ["label", ctx.Locale.t("ToDate")], ["value", DateOnly_iso(model_1.PeriodEnd)], ["onChange", (e_1) => {
        const x_1 = e_1.target.value;
        try {
            const asDt_1 = parse(x_1);
            const iso_1 = DateOnly_iso(asDt_1);
            dispatch(new Message(5, [asDt_1]));
            setQuery("end", iso_1);
        }
        catch (ex_1) {
            console.error(some("Error parsing end date"), ex_1.message);
        }
    }]]), createElement("div", {
        style: {
            flexBasis: 230 + "px",
        },
        children: createElement(Components_CustomerGroupSelect_Z3E74A903, {
            key: "group-select",
            $key: "group-select",
            label: ctx.Locale.t("VismaSync.ChooseGroup"),
            onChange: (groupOpt) => {
                if (groupOpt != null) {
                    setQuery("group", int32ToString(groupOpt.Id));
                }
                else {
                    removeQuery("group");
                }
                dispatch(new Message(6, [groupOpt]));
            },
            selected: unwrap(model_1.SelectedGroup),
        }),
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), drawSummary(ctx.Locale, model_1), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "flex-start",
        gap: 20 + "px ",
    }], (elems_2 = [drawCompanySpread(ctx.Locale, model_1.CompanySpread), createElement("div", createObj(ofArray([["className", join(" ", ["bordered-container"])], ["style", {
        display: "flex",
        flexDirection: "column",
        gap: 20 + "px ",
        minWidth: 400,
    }], (elems_1 = [MuiHelpers_createElement(Typography, [["variant", "h5"], ["children", ctx.Locale.t("Dashboard.Activities.CountByTypeSpread")]]), drawTypeSummary(ctx.Locale, ctx.Language, model_1.TypeSummary)], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

